<template>
    <TabWrapper @save="submit" @change="change" @deploy:preview="$emit('deploy:preview')"
                @deploy:live="$emit('deploy:live')">
        <v-container fluid>
            <v-row no-gutters>
                <v-col cols="12" md="5" xl="4">
                    <Input :read-only="readOnly" v-model="ad_unit" label="DFP AdUnit"></Input>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" md="5" xl="4">
                    <Input :read-only="readOnly" v-model="child_publisher_id" label="DFP Child Publisher Id"></Input>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" md="5" xl="4">
                    <Input :read-only="readOnly" v-model="consent_fallback" label="TCF v2 Fallback"></Input>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" md="5" xl="4">
                    <Input :read-only="readOnly" v-model="publisher_id" label="TCF v2 PublisherId"></Input>
                </v-col>
            </v-row>
        </v-container>
    </TabWrapper>
</template>

<script>
import TabWrapper from "./TabWrapper";
import Input from "../../../components/Inputs/Input";

export default {
    name: "AdServer",
    components: {Input, TabWrapper},
    props: ['readOnly'],
    data: () => {
        return {
            ad_unit: null,
            child_publisher_id: null,
            consent_fallback: null,
            publisher_id: null,
        }
    },
    mounted() {
        this.init();
        this.$emit('activeComponent', this);
    },
    computed: {
        vuexState() {
            return this.$store.state.display;
        },
        siteDetails() {
            return this.vuexState.siteDetails;
        },
        activeTab() {
            return this.$store.state.display.activeTab;
        }
    },
    methods: {
        init() {
            if (this.siteDetails) {
                this.ad_unit = this.siteDetails.Current.Adunit;
                this.child_publisher_id = this.siteDetails.Current.ChildPublisherId;
                this.consent_fallback = this.siteDetails.Current.ConsentFallback;
                this.publisher_id = this.siteDetails.Current.PublisherId;
            }
        },
        submit() {
            this.$emit('submit', this);
        },
        change() {
            if (this.$store.state.display.previousTab === this.$options._componentTag) {
                this.$emit('change', this);
            } else if (this.activeTab === this.$options._componentTag) {
                this.$emit('activeComponent', this);
            }
        },
        dataChanged() {
            let changed = false;
            if (this.ad_unit !== this.siteDetails.Current.Adunit ||
                this.child_publisher_id !== this.siteDetails.Current.ChildPublisherId ||
                this.consent_fallback !== this.siteDetails.Current.ConsentFallback ||
                this.publisher_id !== this.siteDetails.Current.PublisherId) {
                changed = true;
            }
            return changed;
        },
        getBody() {
            return {
                publisher_id: this.siteDetails.Site.PublisherId,
                site_id: this.siteDetails.Site.SiteId,
                type_id: this.siteDetails.Current.SitetypeId,
                Adunit: this.ad_unit,
                ChildPublisherId: this.child_publisher_id,
                ConsentFallback: this.consent_fallback,
                PublisherId: this.publisher_id,
            }
        }
    },
    watch: {
        siteDetails() {
            this.init();
        }
    }
}
</script>

<style scoped>

</style>